<template>
	<div class="animated fadeInRight repair-ledger-container">
		<el-row :gutter="20">
			<el-col :span="24">
				<el-card class="box-card">
					<div slot="header" style="text-align: left;">
						<span>维修台账</span>
					</div>
					<div class="card-body">
						<el-row :gutter="20" style="margin-bottom: 15px;">
							<el-col :span="6">
								<el-input v-model="conditions.initiatorName" placeholder="请输入报修人" clearable />
							</el-col>
							<el-col :span="6">
								<el-button type="primary" @click="queryData">
									<i class="el-icon-search"></i> 查询
								</el-button>
								<el-button @click="resetQuery">
									<i class="el-icon-refresh"></i> 重置
								</el-button>
							</el-col>
						</el-row>
					</div>
				</el-card>
			</el-col>
		</el-row>

		<el-row :gutter="20">
			<el-col :span="24">
				<el-card class="box-card">
					<div class="table-container" v-loading="loading">
						<el-table :data="repairList" border style="width: 100%"
							:header-cell-style="{ background: '#F5F7FA', color: '#606266' }">
							<el-table-column prop="orderType" label="所属项目" align="center" width="100" fixed>
								<template slot-scope="scope">
									{{ getOrderTypeText(scope.row.orderType) }}
								</template>
							</el-table-column>
							<el-table-column label="维修地点" align="center" min-width="150">
								<template slot-scope="scope">
									{{ getLocationText(scope.row) }}
								</template>
							</el-table-column>
							<el-table-column prop="itemName" label="维修部位" align="center" min-width="120" />
							<el-table-column prop="problemDesc" label="问题描述" align="center" min-width="200"
								show-overflow-tooltip />
							<el-table-column prop="initiatorName" label="报修人" align="center" width="100" />
							<el-table-column prop="createTime" label="报修时间" align="center" width="160" />
							<!--      <el-table-column label="项目部建议维修方案" align="center" width="150">
                <template slot-scope="scope">
                  {{ getCanRepairText(scope.row.canRepair) }}
                </template>
              </el-table-column> -->
							<el-table-column label="资金来源" align="center" width="120">
								<template slot-scope="scope">
									{{ getFundSourceText(scope.row.isOutsource) }}
								</template>
							</el-table-column>
							<el-table-column label="供应商" align="center" min-width="120">
								<template slot-scope="scope">
									{{ getSupplierNames(scope.row) }}
								</template>
							</el-table-column>
							<el-table-column label="报价" align="center" width="100">
								<template slot-scope="scope">
									{{ getQuoteAmount(scope.row) }}
								</template>
							</el-table-column>
							<el-table-column label="审核控制价" align="center" width="120">
								<template slot-scope="scope">
									{{ getAuditControlPrice(scope.row) }}
								</template>
							</el-table-column>
							<el-table-column label="维修经办责任人" align="center" width="130">
								<template slot-scope="scope">
									<div v-if="getHandlerSignImage(scope.row)">
										<el-image :src="getHandlerSignImage(scope.row)"
											:preview-src-list="[getHandlerSignImage(scope.row)]" fit="contain"
											style="width: 80px; height: 40px; cursor: pointer;" />
									</div>
									<span v-else>-</span>
								</template>
							</el-table-column>
							<el-table-column label="维修实施单位" align="center" min-width="120">
								<template slot-scope="scope">
									{{ getSupplierNames(scope.row) }}
								</template>
							</el-table-column>


						<el-table-column label="审计审核意见" align="center" width="120">
							<template slot-scope="scope">
								<div v-if="getManagerSignImage(scope.row, '审计')">
									<el-image :src="getManagerSignImage(scope.row, '审计')"
										:preview-src-list="[getManagerSignImage(scope.row, '审计')]" fit="contain"
										style="width: 80px; height: 40px; cursor: pointer;" />
								</div>
							</template>
						</el-table-column>

						    <el-table-column label="项目负责人审核意见" align="center" width="120">
								<template slot-scope="scope">
									<div v-if="getManagerSignImage(scope.row, '项目')">
										<el-image :src="getManagerSignImage(scope.row, '项目')"
											:preview-src-list="[getManagerSignImage(scope.row, '项目')]" fit="contain"
											style="width: 80px; height: 40px; cursor: pointer;" />
									</div>
								</template>
							</el-table-column>

							<el-table-column label="维修岗负责人审核意见" align="center" width="120">
								<template slot-scope="scope">
									<div v-if="getManagerSignImage(scope.row, '维修岗')">
										<el-image :src="getManagerSignImage(scope.row, '维修岗')"
											:preview-src-list="[getManagerSignImage(scope.row, '维修岗')]" fit="contain"
											style="width: 80px; height: 40px; cursor: pointer;" />
									</div>
								</template>
							</el-table-column>


							<el-table-column label="部门审核意见" align="center" width="120">
								<template slot-scope="scope">
									<div v-if="getManagerSignImage(scope.row,'部门负责人')">
										<el-image :src="getManagerSignImage(scope.row,'部门负责人')"
											:preview-src-list="[getManagerSignImage(scope.row,'部门负责人')]" fit="contain"
											style="width: 80px; height: 40px; cursor: pointer;" />
									</div>
								</template>
							</el-table-column>
							<el-table-column label="分管领导审核意见" align="center" width="120">
								<template slot-scope="scope">
									<div v-if="getManagerSignImage(scope.row, '分管领导')">
										<el-image :src="getManagerSignImage(scope.row, '分管领导')"
											:preview-src-list="[getManagerSignImage(scope.row, '分管领导')]" fit="contain"
											style="width: 80px; height: 40px; cursor: pointer;" />
									</div>
								</template>
							</el-table-column>
							<el-table-column label="副总经理审核意见" align="center" width="150">
								<template slot-scope="scope">
									<div v-if="getManagerSignImage(scope.row, '副总经理')">
										<el-image :src="getManagerSignImage(scope.row, '副总经理')"
											:preview-src-list="[getManagerSignImage(scope.row, '副总经理')]" fit="contain"
											style="width: 80px; height: 40px; cursor: pointer;" />
									</div>
								</template>
							</el-table-column>
							<el-table-column label="总经理审核意见" align="center" width="150">
								<template slot-scope="scope">
									<div v-if="getManagerSignImage(scope.row, '总经理')">
										<el-image :src="getManagerSignImage(scope.row, '总经理')"
											:preview-src-list="[getManagerSignImage(scope.row, '总经理')]" fit="contain"
											style="width: 80px; height: 40px; cursor: pointer;" />
									</div>
								</template>
							</el-table-column>

							<el-table-column label="董事长审核意见" align="center" width="150">
								<template slot-scope="scope">
									<div v-if="getManagerSignImage(scope.row, '董事长')">
										<el-image :src="getManagerSignImage(scope.row, '董事长')"
											:preview-src-list="[getManagerSignImage(scope.row, '董事长')]" fit="contain"
											style="width: 80px; height: 40px; cursor: pointer;" />
									</div>
								</template>
							</el-table-column>
							<el-table-column label="维修进度" align="center" width="100">
								<template slot-scope="scope">
									<el-tag :type="getProgressTagType(scope.row)" size="small">
										{{ getRepairProgress(scope.row) }}
									</el-tag>
								</template>
							</el-table-column>
							<el-table-column label="维修前水印照片" align="center" width="150">
								<template slot-scope="scope">
									<div class="image-cell" v-if="getImageList(scope.row.problemImgs).length > 0">
										<el-image v-for="(img, idx) in getImageList(scope.row.problemImgs).slice(0, 3)"
											:key="idx" :src="img"
											:preview-src-list="getImageList(scope.row.problemImgs)" fit="cover"
											class="table-image" />
									</div>
									<span v-else>-</span>
								</template>
							</el-table-column>
							<el-table-column label="维修中水印照片" align="center" width="150">
								<template slot-scope="scope">
									<div class="image-cell" v-if="getProcessImages(scope.row).length > 0">
										<el-image v-for="(img, idx) in getProcessImages(scope.row).slice(0, 3)"
											:key="idx" :src="img" :preview-src-list="getProcessImages(scope.row)"
											fit="cover" class="table-image" />
									</div>
									<span v-else>-</span>
								</template>
							</el-table-column>
							<el-table-column label="维修后水印照片" align="center" width="150">
								<template slot-scope="scope">
									<div class="image-cell" v-if="getImageList(scope.row.repairAfterImgs).length > 0">
										<el-image
											v-for="(img, idx) in getImageList(scope.row.repairAfterImgs).slice(0, 3)"
											:key="idx" :src="img"
											:preview-src-list="getImageList(scope.row.repairAfterImgs)" fit="cover"
											class="table-image" />
									</div>
									<span v-else>-</span>
								</template>
							</el-table-column>
							<el-table-column prop="repairMaterialFee" label="维修实际费用" align="center" width="120" />
							<el-table-column label="支付状态" align="center" width="100">
								<template slot-scope="scope">
									{{ getPayStatusText(scope.row.payStatus) }}
								</template>
							</el-table-column>
						</el-table>
					</div>

					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
						layout="total, sizes, prev, pager, next, jumper" :total="page.total"
						style="margin-top: 20px;" />
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {
		getCommunityId
	} from '@/api/community/communityApi'
	import request from '@/utils/request'

	export default {
		name: 'RepairLedgerList',
		data() {
			return {
				loading: false,
				repairList: [],
				conditions: {
					initiatorName: ''
				},
				page: {
					current: 1,
					size: 10,
					total: 0
				},
				currentRoleKey: '',
				currentRoleRelCd: ''
			}
		},
		created() {
			this.fetchData()
		},
		methods: {
			// 查询所有工单（新接口）
			async queryAllOrders(params) {
				const response = await request({
					url: '/app/pms.queryAllOrder',
					method: 'get',
					params
				})
				const res = response.data
				if (res.code === 0) {
					return {
						data: res.data || [],
						total: res.total || res.records || 0
					}
				} else {
					throw new Error(res.msg || '查询失败')
				}
			},

			async fetchData() {
				this.loading = true
				try {
					const params = {
						...this.conditions,
						communityId: getCommunityId(),
						page: this.page.current,
						row: this.page.size
					}

					// 过滤空值参数
					Object.keys(params).forEach(key => {
						if (params[key] === '') {
							delete params[key]
						}
					})

					const res = await this.queryAllOrders(params)
					this.repairList = res.data || []
					this.page.total = res.total || 0
				} catch (error) {
					console.error('查询维修台账失败:', error)
					this.$message.error('查询失败，请稍后重试')
				} finally {
					this.loading = false
				}
			},
			formatDate(date) {
				if (!date) return ''
				const d = new Date(date)
				const year = d.getFullYear()
				const month = String(d.getMonth() + 1).padStart(2, '0')
				const day = String(d.getDate()).padStart(2, '0')
				return `${year}-${month}-${day}`
			},

			// 获取报修类型文本
			getOrderTypeText(orderType) {
				const typeMap = {
					'0': '室内报修',
					'1': '公区报修'
				}
				return typeMap[String(orderType)] || '-'
			},

			// 获取是否能修文本
			getCanRepairText(canRepair) {
				if (canRepair === null || canRepair === undefined) {
					return '-'
				}
				const canRepairMap = {
					'0': '不能修',
					'1': '能修'
				}
				return canRepairMap[String(canRepair)] || '-'
			},

			// 获取资金来源文本（是否外委）
			getFundSourceText(isOutsource) {
				if (isOutsource === null || isOutsource === undefined) {
					return '-'
				}
				const fundSourceMap = {
					'1': '物业修理范围',
					'2': '不是物业修理范围'
				}
				return fundSourceMap[String(isOutsource)] || '-'
			},

			// 获取位置文本
			getLocationText(row) {
				if (!row) return '-'

				// 如果是公区报修（orderType === 1），使用 addressDetail
				if (row.orderType === 1 || row.orderType === '1') {
					return row.addressDetail || '-'
				}
				// 如果是室内报修（orderType === 0），组合楼栋-单元-房号
				else if (row.orderType === 0 || row.orderType === '0') {
					const building = row.floorNum || row.buildingNum || ''
					const unit = row.unitNum || ''
					const room = row.roomNum || row.roomName || ''

					if (building || unit || room) {
						let location = ''
						if (building) location += `${building}栋`
						if (unit) location += `${unit}单元`
						if (room) location += room
						return location || row.roomName || '-'
					}

					return row.roomName || '-'
				}

				return row.addressDetail || row.roomName || '-'
			},

			// 获取图片列表
			getImageList(imgStr) {
				if (!imgStr) return []
				try {
					// 如果是数组直接返回
					if (Array.isArray(imgStr)) {
						return imgStr.filter(img => img)
					}
					// 如果是JSON字符串，解析后返回
					if (typeof imgStr === 'string') {
						// 尝试JSON解析
						try {
							const parsed = JSON.parse(imgStr)
							if(parsed){
								var arr = parsed.images.split(',')
								return Array.isArray(arr) ? arr : []
							}
						} catch (e) {
							// 如果不是JSON，按逗号分割
							return imgStr.split(',').filter(img => img && img.trim())
						}
					}
					return []
				} catch (error) {
					console.error('解析图片列表失败:', error)
					return []
				}
			},

			// 获取供应商名
			getSupplierNames(row) {
				if (!row) return '-'

				// 如果有 supplierInfo 字段（JSON字符串或对象）
				if (row.supplierInfo) {
					try {
						let supplierData = row.supplierInfo
						if (typeof supplierData === 'string') {
							supplierData = JSON.parse(supplierData)
						}

						if (Array.isArray(supplierData)) {
							const names = supplierData.map(s => s.name || s.supplierName).filter(n => n)
							return names.join('，') || '-'
						} else if (supplierData.name || supplierData.supplierName) {
							return supplierData.name || supplierData.supplierName
						}
					} catch (e) {
						console.error('解析供应商信息失败', e)
					}
				}

				// 如果有单独的 supplierName 字段
				if (row.supplierName) {
					return row.supplierName
				}

				return '-'
			},

			// 获取报价金额
			getQuoteAmount(row) {
				if (!row) return '-'

				// 如果有 quoteInfo 字段（JSON字符串）
				if (row.quoteInfo) {
					try {
						let quoteData = row.quoteInfo
						if (typeof quoteData === 'string') {
							quoteData = JSON.parse(quoteData)
						}

						if (quoteData.num) {
							return quoteData.num
						}
					} catch (e) {
						console.error('解析报价信息失败:', e)
					}
				}

				// 如果有单独的 quoteAmount 字段
				if (row.quoteAmount) {
					return row.quoteAmount
				}

				return '-'
			},

			// 获取审核控制
			getAuditControlPrice(row) {
				if (!row) return '-'

				// 如果有 auditControl 字段（JSON字符串）
				if (row.auditControl) {
					try {
						let auditData = row.auditControl
						if (typeof auditData === 'string') {
							auditData = JSON.parse(auditData)
						}

						if (auditData.controlNum) {
							return auditData.controlNum
						}
					} catch (e) {
						console.error('解析审核控制价失败', e)
					}
				}

				// 如果有单独的 auditControlPrice 字段
				if (row.auditControlPrice) {
					return row.auditControlPrice
				}

				return '-'
			},

			// 获取维修中图片（特殊处理JSON格式
			getProcessImages(row) {
				if (!row || !row.repairProcessImgs) return []

				try {
					let imgData = row.repairProcessImgs

					// 如果是字符串，尝试解析
					if (typeof imgData === 'string') {
						// 尝试解析为JSON对象
						try {
							const parsed = JSON.parse(imgData)
							// 如果解析后有 images 字段
							if (parsed.images) {
								if (typeof parsed.images === 'string') {
									return parsed.images.split(',')
								} else if (Array.isArray(parsed.images)) {
									return parsed.images.filter(img => img)
								}
							}
							// 如果解析后是数组
							if (Array.isArray(parsed)) {
								return parsed.filter(img => img)
							}
						} catch (e) {
							// 如果不是JSON，按逗号分割
							return imgData.split(',').filter(img => img && img.trim())
						}
					}

					// 如果是数组直接返回
					if (Array.isArray(imgData)) {
						return imgData.filter(img => img)
					}

					return []
				} catch (error) {
					console.error('解析维修中图片失败', error)
					return []
				}
			},

			// 解析签名信息
			parseSignPics(row) {
				if (!row || !row.signPics) return []

				try {
					let signData = row.signPics
					if (typeof signData === 'string') {
						signData = JSON.parse(signData)
					}

					if (Array.isArray(signData)) {
						return signData
					}

					return []
				} catch (error) {
					console.error('解析签名信息失败:', error)
					return []
				}
			},

			// 获取部门审核意见（roleId: 5 - 部门负责人）
			getDeptAuditOpinion(row) {
				const signList = this.parseSignPics(row)
				const deptSign = signList.find(s => String(s.roleId) === '5')

				if (deptSign && deptSign.img) {
					return '已同意'
				}

				return '-'
			},

			// 获取部门签名图片
			getDeptSignImage(row) {
				const signList = this.parseSignPics(row)
				const deptSign = signList.find(s => String(s.roleId) === '5')
				return deptSign && deptSign.img ? deptSign.img : null
			},

			// 获取维修岗签名图片（roleId: 4 - 维修岗负责人
			getHandlerSignImage(row) {
				const signList = this.parseSignPics(row)
				const handlerSign = signList.find(s => String(s.roleId) === '4')
				return handlerSign && handlerSign.img ? handlerSign.img : null
			},

			// 获取分管领导审核意见（roleId: 9 - 分管领导
			getLeaderAuditOpinion(row) {
				const signList = this.parseSignPics(row)
				const leaderSign = signList.find(s => String(s.roleId) === '9')

				if (leaderSign && leaderSign.img) {
					return '已同意'
				}

				return '-'
			},

			// 获取分管领导签名图片
			getLeaderSignImage(row) {
				const signList = this.parseSignPics(row)
				const leaderSign = signList.find(s => String(s.roleId) === '9')
				return leaderSign && leaderSign.img ? leaderSign.img : null
			},

			// 获取总（副总）经理审核意见（roleId: 2 - 总经理 / roleId: 10 - 董事长）
			getManagerAuditOpinion(row) {
				const signList = this.parseSignPics(row)
				const managerSign = signList.find(s => String(s.roleId) === '2' || String(s.roleId) === '10')

				if (managerSign && managerSign.img) {
					return '已同意'
				}

				return '-'
			},

			// 获取总（副总）经理签名图片
			getManagerSignImage(row, name) {
				const signList = this.parseSignPics(row)
				const managerSign = signList.find(s => String(s.roleName).includes(name))
				return managerSign && managerSign.img ? managerSign.img : null
			},

			// 获取支付状态文
			getPayStatusText(payStatus) {
				if (payStatus === null || payStatus === undefined) {
					return '-'
				}
				const statusMap = {
					'0': '未支付',
					'1': '待支付',
					'2': '已支付'
				}
				return statusMap[String(payStatus)] || '-'
			},

			// 格式化状态名
			formatStatusName(status) {
				const statusMap = {
					'0': '待接单',
					'1': '待派工',
					'2': '待处理',
					'3': '处理中',
					'4': '待验收',
					'5': '已完成',
					'6': '已驳回',
					'7': '已关闭',
					'8': '已取消'
				}
				return statusMap[String(status)] || '-'
			},

			// 获取维修进度（根据图片判断）
			getRepairProgress(row) {
				if (!row) return '待维修'

				// 如果有验收图片（维修后图片），状态为已完成
				const afterImages = this.getImageList(row.repairAfterImgs)
				if (afterImages.length > 0) {
					return '已完成'
				}

				// 如果有维修中图片，状态为维修中
				const processImages = this.getProcessImages(row)
				if (processImages.length > 0) {
					return '维修中'
				}

				// 否则为待维修
				return '待维修'
			},

			// 获取维修进度 tag 类型
			getProgressTagType(row) {
				if (!row) return 'info'

				// 如果有验收图片（维修后图片），状态为已完成 - 绿色
				const afterImages = this.getImageList(row.repairAfterImgs)
				if (afterImages.length > 0) {
					return 'success'
				}

				// 如果有维修中图片，状态为维修中 - 蓝色
				const processImages = this.getProcessImages(row)
				if (processImages.length > 0) {
					return 'primary'
				}

				// 否则为待维修 - 橙色
				return 'warning'
			},

			queryData() {
				this.page.current = 1
				this.fetchData()
			},
			resetQuery() {
				this.conditions = {
					initiatorName: ''
				}
				this.page.current = 1
				this.fetchData()
			},
			handleSizeChange(val) {
				this.page.size = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.page.current = val
				this.fetchData()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.repair-ledger-container {
		padding: 20px;

		.box-card {
			margin-bottom: 20px;
		}

		.table-container {
			// el-table 自带滚动，不需要额外设置
		}

		// 图片单元格样式
		.image-cell {
			display: flex;
			gap: 5px;
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;
			padding: 5px 0;
		}

		.table-image {
			width: 40px;
			height: 40px;
			border-radius: 4px;
			cursor: pointer;

			&:hover {
				opacity: 0.8;
			}
		}

		.el-pagination {
			margin-top: 20px;
			text-align: right;
		}
	}
</style>